import React from 'react';
import { motion } from 'framer-motion';
import { ParticleBackground } from './ParticleBackground';
interface HeroScreenProps {
  onStart: () => void;
}
export function HeroScreen({
  onStart
}: HeroScreenProps) {
  return <motion.div className="relative min-h-screen min-h-[100dvh] w-full overflow-hidden flex flex-col items-center justify-center text-center px-5 md:px-4" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0,
    y: -50
  }} transition={{
    duration: 1
  }} data-id="element-178">
      <ParticleBackground data-id="element-179" />

      {/* Background Gradient/Vignette */}
      <div className="absolute inset-0 z-10" style={{
      background: 'linear-gradient(to bottom, transparent 0%, rgba(8,8,8,0.5) 50%, rgba(8,8,8,1) 100%)'
    }} data-id="element-180" />

      {/* Content */}
      <div className="relative z-20 max-w-5xl mx-auto flex flex-col items-center" data-id="element-181">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5,
        duration: 1
      }} className="w-px h-10 md:h-16 bg-gradient-to-b from-transparent to-[var(--accent)] mb-5 md:mb-8" data-id="element-182" />

        <motion.h1 className="text-3xl sm:text-5xl md:text-7xl lg:text-8xl font-serif font-bold tracking-widest text-[var(--text-primary)] mb-4 md:mb-6 text-shadow-glow uppercase leading-tight" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.8,
        duration: 1.2,
        ease: 'easeOut'
      }} data-id="element-183">
          Comenzar la
          <br data-id="element-184" />
          <span className="text-transparent bg-clip-text bg-gradient-to-b from-white to-gray-500" data-id="element-185">
            Investigación
          </span>
        </motion.h1>

        <motion.p className="text-base sm:text-lg md:text-xl text-[var(--text-secondary)] max-w-xs sm:max-w-md md:max-w-lg mb-8 md:mb-12 font-light tracking-wide leading-relaxed px-2" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.5,
        duration: 1
      }} data-id="element-186">
          Una serie interactiva donde la historia se detiene hasta que ustedes
          investigan.
        </motion.p>

        <motion.button onClick={onStart} className="group relative px-8 py-3 md:px-12 md:py-4 border border-[var(--accent)] text-[var(--text-primary)] uppercase tracking-[0.15em] md:tracking-[0.2em] text-xs sm:text-sm md:text-base transition-all duration-500 hover:bg-[var(--accent-glow)] focus:outline-none focus:ring-2 focus:ring-[var(--accent)] focus:ring-offset-2 focus:ring-offset-black" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 2,
        duration: 0.8
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} data-id="element-187">
          <span className="relative z-10" data-id="element-188">Iniciar Caso</span>
          <div className="absolute inset-0 bg-[var(--accent)] opacity-0 group-hover:opacity-10 transition-opacity duration-500 blur-md" data-id="element-189" />
        </motion.button>
      </div>

      {/* Bottom Silhouette */}
      <div className="absolute bottom-0 left-0 right-0 h-20 md:h-32 bg-gradient-to-t from-black to-transparent z-10" data-id="element-190" />
    </motion.div>;
}